/* src/app/order/components/order-details/product-details/price-factors-details/price-factors-details.style.scss */
.order-card .details-body .card-header-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 5px;
}
.order-card .details-body .card-header {
  display: flex;
  flex-wrap: wrap;
  font-size: 22px;
  font-weight: bold;
  color: #007d40;
  margin: 0 0 30px 0;
  overflow-wrap: break-word;
}
.order-card .details-body .card-header .company-name {
  margin: 0;
  color: #007d40;
}
.order-card .details-body .card-header.collapsed {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  margin: 0;
}
.order-card .details-body .card-header.collapsed .company-name {
  margin: 0;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.order-card .details-body .toggle-details-section {
  font-family: Arial, sans-serif;
  font-size: 12px;
  font-weight: bold;
  line-height: 1.33;
  text-align: center;
  color: #007d40;
  cursor: pointer;
  text-decoration: none;
  white-space: nowrap;
}
.order-card .details-body .toggle-details-section nb-icon {
  position: relative;
  top: 2px;
}
.client-property-label {
  font-family: Arial, sans-serif;
  font-size: 12px;
  font-weight: bold;
  line-height: 1.33;
  color: #007d40;
  margin-bottom: 0;
  display: inline;
}
.client-property-label span {
  vertical-align: middle !important;
  text-transform: uppercase;
}
.last-client-property-label {
  margin-top: 30px !important;
  display: flex;
}
.client-property {
  font-family: Arial, sans-serif;
  font-size: 15px;
  font-weight: 600;
  line-height: 1.6;
  color: #585858;
  margin-bottom: 20px !important;
  overflow-wrap: break-word;
}
.with-padding-bottom {
  padding-bottom: 20px;
}
.change-button {
  margin-top: 20px;
  float: right;
}
.change-button.collapsed {
  display: none;
}
.radio-row.form-row {
  flex-wrap: nowrap;
  align-items: baseline;
}
.radio-row.form-row .radio-column {
  min-width: 80px;
}
@media screen and (max-width: 767px) {
  .radio-row.form-row {
    flex-direction: column-reverse;
  }
}
#price-factors {
  vertical-align: middle;
  font-family: Arial, sans-serif;
  font-size: 13px;
  line-height: 1.38;
  color: #585858;
  font-size: 15px;
}
#price-factors .margin-bottom10 {
  margin-bottom: 10px;
}
#price-factors .total-modifiers {
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  font-weight: bold;
  line-height: 1.33;
  font-family: Arial, sans-serif;
  color: #007d40;
  text-transform: uppercase;
}
#price-factors .attached-question-row {
  margin-bottom: 10px;
}
#price-factors .attached-question-row .attached-question-answer {
  font-weight: bold;
}
#price-factors .translation-wrapper {
  margin-left: 80px;
}
::ng-deep .total-modifiers-tooltip {
  width: 550px;
  white-space: normal;
}
/*# sourceMappingURL=price-factors-details.style.css.map */
